// OnboardingLayout.tsx
import React from "react";
import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Typography,
  styled,
} from "@mui/material";
import { StepIconProps } from "@mui/material";

const RoundStepIcon: React.FC<StepIconProps> = (props) => {
  const { active = false, completed = false } = props;

  const bgColor = active || completed ? "white" : "rgba(255,255,255,0.3)";

  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        borderRadius: "50%",
        backgroundColor: bgColor,
      }}
    />
  );
};

interface OnboardingLayoutProps {
  children: React.ReactNode;
  currentStep: number;
}

const steps = [
  "Step 1: Sign up",
  "Step 2: Email Confirmation",
  "Step 3: HubSpot Sync",
];

const SidebarContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#4A2C6B",
  color: "white",
  padding: theme.spacing(4),
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
}));

const StepperStyled = styled(Stepper)(({ theme }) => ({
  "& .MuiStepLabel-label": {
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "0.9rem",
  },
  "& .MuiStepLabel-label.Mui-active": {
    color: "white",
    fontWeight: 600,
  },
  "& .MuiStepLabel-label.Mui-completed": {
    color: "white",
    fontWeight: 600,
  },
}));

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
  currentStep,
}) => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* Left Content Area */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <Container maxWidth="sm">{children}</Container>
      </Box>

      {/* Right Sidebar */}
      <SidebarContainer sx={{ width: 320 }}>
        <Typography variant="h6" sx={{ mb: 4, fontWeight: 600 }}>
          Quick & Easy Setup
        </Typography>
        <StepperStyled activeStep={currentStep} orientation="vertical">
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={RoundStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </StepperStyled>
      </SidebarContainer>
    </Box>
  );
};
